module.exports = __webpack_public_path__ + "static/media/ev-en.86feefd2.svg";